import React from 'react';
import { Button } from './ui/button';
import { Eye } from 'lucide-react';
import { getAlbumTitleFontClass } from '../lib/albumTitleFonts';

const SimpleAlbumCard = ({ album, index = 0, onViewAlbum }) => {
  const titleFontClass = getAlbumTitleFontClass(album.titleFont);

  return (
    <div 
      className="group relative overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-200 cursor-pointer"
    >
      {/* Image */}
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={album.coverImage}
          alt={album.title}
          className="w-full h-full object-cover"
          loading={index < 4 ? "eager" : "lazy"}
          decoding="async"
          fetchPriority={index < 2 ? "high" : "auto"}
        />
        
        {/* Dark Overlay on Hover */}
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/45 transition-colors duration-200"></div>
        
        {/* Content - Shows on Hover - Fixed to THIS card only */}
        <div className="absolute inset-0 flex flex-col items-center justify-end opacity-0 group-hover:opacity-100 transition-opacity duration-200 p-8">
          <div className="text-center space-y-3 w-full">
            {/* Album Title */}
            <h3 className={`text-2xl font-bold text-white ${titleFontClass}`}>
              {album.title}
            </h3>
            
            {/* Date */}
            <p className="text-white/90 text-sm mb-4">
              {album.date}
            </p>
            
            {/* View Album Button - At Bottom */}
            <Button
              onClick={(e) => {
                e.stopPropagation();
                onViewAlbum(album);
              }}
              className="bg-white text-black hover:bg-gray-100 transition-colors duration-200 w-full"
            >
              <Eye className="w-4 h-4 mr-2" />
              View Album
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SimpleAlbumCard;
